module.exports = __webpack_public_path__ + "fonts/cataneo_1b4969fc2e56decc654f7f1ee89ddfd9.ttf";